export default __webpack_public_path__ + "static/Flexible_Electrical_Cable-2a58f572dad4b53fdfd0bc9cce595935.png";